window.addEventListener(
  "load",
  function () {
    //In banners paragraph when there's a video, it will be opened in a pop up when play button is clicked
    let playButton = document.querySelectorAll(
      ".paragraph-banners .play-button"
    );

    playButton.forEach(function (playBtn) {
      playBtn.addEventListener("click", function (event) {
        event.preventDefault();

        let playBtnId = playBtn.getAttribute("data-bs-target");

        if (event.target.getAttribute("data-bs-target") === playBtnId) {
          let modalBody = document
            .getElementById(playBtnId.replace("#", ""))
            .querySelector(".modal-body");
          while (modalBody.firstChild)
            modalBody.removeChild(modalBody.firstChild);

          let iframe = this.closest(".two-cards").querySelector("iframe");

          let iframeNode = document.importNode(iframe, true);

          modalBody.appendChild(iframeNode);
        }
      });
    });

    // grab elements as array, rather than as NodeList
  //  let elements = document.querySelectorAll(
  //    ".paragraph-banners .banner-full-width"
 //   );
  //  elements = Array.prototype.slice.call(elements);

    // and then make each element do something on scroll
  //  elements.forEach(function (element) {
 //     window.addEventListener("scroll", function (evt) {
    //    const parallaxImage = element.querySelector("#imagen-parallax");
        //console.log(element.offsetTop);
   //     if (parallaxImage) {
     //     let scrollStart = element.offsetTop;

     //     if (window.pageYOffset < scrollStart) {
     //       var scrolled = window.pageYOffset;
     //       var imageScrolled = scrolled * 3 * -1;
     //     }

    //      parallaxImage.style.transform = "translateY(" + imageScrolled + "px)";
   //     }
  //    });
  //  });
  },
  false
);
